const SimpleArrowDownSvg = ({size = 24, color = '#222'}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="m12 20-.354.354.354.353.354-.353zm.5-15a.5.5 0 0 0-1 0zm-6.854 9.354 6 6 .708-.708-6-6zm6.708 6 6-6-.708-.708-6 6zM12.5 20V5h-1v15z"
            fill={color}
        />
    </svg>
);
export default SimpleArrowDownSvg;
